/*
 * @CopyRight: 广州仰望星空云科技有限公司
 * @Author: Leven
 * @Email: liwenbo@xinyu668.com
 * @Date: 2023-09-13 17:09:48
 * @LastEditTime: 2024-08-30 16:32:45
 * @Description:
 */
/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-18 15:05:10
 * @Description  : 入口配置
 */
import axios from 'axios';
import { typeIs } from '@ywxk/util/validate';
import { constConf } from '@GLOBAL/constConf';

const { ORIGIN_ENV_PROJECT_ASSETS, ORIGIN_ENV_PROJECT, PROJECT, IS_PROD, ENV, PRIVATE_DOMAIN } = constConf

// 获取下载包的路径(新版:从前端管理后台官网配置获取)
// 传key可返回指定key的value
export let getDownloadPath = async (key) => {
  try {
    const res = await axios.get(`${PRIVATE_DOMAIN}/${ENV}/websiteConfig/${PROJECT}/download.json?${+new Date()}`);
    const data = res.data;
    return Promise.resolve(data[key] || data);
  } catch (error) {
    console.error('getDownloadPath-error', error);
  }
};


// 读取自身项目的入口配置,代码在: 仓库/项目/assets/json/enter.json
function getRemoteEnter() {
  const remote = `${ORIGIN_ENV_PROJECT_ASSETS}/json/enter.json?${+new Date()}`;
  return axios.get(remote).then((res) => res.data);
}

/**
 * 获取vuecommonality的项目配置
 * @param {String} target
 * target值是对应项目key，例如官网：official，周星：weekStar，分享：invite
 * target为 customerService时必须要传search参数;
 * search参数有三个：source(来源：默认为app)、noTurn(是否跳转到PC端：0|1)、mark(活动标记：自定义值，可传活动目录名)
 * search完整参数例子：【塔罗牌】source=app&noTurn=1&mark=StarSignComplaint
 */
type TargetType = Array<any> | object | string
export let getEnterConf = async (target: TargetType, search: string) => {
  // 请求入口配置
  const data = await getRemoteEnter();
  if (!data) return {};


  // 拼装数据
  const newData = (key, params) => {
    let res = data[key];
    if (res) {
      const symbol = res.url.indexOf('?') === -1 ? '?' : '&'
      res = {
        ...res,
        wholeUrl: `${ORIGIN_ENV_PROJECT}${res.url}${params ? symbol : ''}${params}${res.path || ''}`,
      };
    }
    return res;
  };

  // 返回逻辑
  getEnterConf = (target: TargetType, search: string) => {
    // 处理参数
    if (search) search = search.indexOf('?') !== -1 ? search.replace('?', '') : search
    const DEBUG = IS_PROD ? '' : 'debug=1';
    const params = search ? `${DEBUG ? DEBUG + '&' : ''}${search}` : DEBUG;
    // 返回结果
    let finallyVal = null;
    if (typeIs('Array', target)) {
      finallyVal = target.map((key) => newData(key, params));
    } else if (typeIs('String', target)) {
      finallyVal = newData(target, params);
    } else {
      finallyVal = {};
      Object.keys(data).forEach((key) => {
        finallyVal[key] = newData(key, params);
      });
    }
    return Promise.resolve(finallyVal);
  };

  return getEnterConf(target, search);
};
